import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyB4D0NouXISP3NeltpheeRp0KIEX-pvW-A",
  authDomain: "jewellery-92594.firebaseapp.com",
  projectId: "jewellery-92594",
  storageBucket: "jewellery-92594.firebasestorage.app",
  messagingSenderId: "401991431524",
  appId: "1:401991431524:web:8da79035c9ed83e4adf671",
  measurementId: "G-HLXFT9GF86"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Cloud Functions (asia-south1 — same region every deployed
// Cloud Function lives in, see functions/src/index.ts)
export const functions = getFunctions(app, 'asia-south1');

export default app;